import { registerComponent } from '../app'
import { VARIANT_CHANGE } from '../events'

const VariantPrimaryBackground = (scope, el) => {
	scope.on(VARIANT_CHANGE, variant => {
		if (!variant.primary_color || !variant.primary_color.length) return
		el.style.backgroundColor = variant.primary_color
	})
}

registerComponent('variant-primary-background', VariantPrimaryBackground)
